var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"cms-table-button iconfont",class:_vm.type,attrs:{"href":"javascript:void(0)","title":_vm.title}},[_c('i',{class:_vm.icon[_vm.type]})])}
var staticRenderFns = []

export { render, staticRenderFns }